export const getLocalStorageKey = (userId: string): string =>
    `showedEnableDetectionReminder.${userId}`;
